import { createFileRoute } from '@tanstack/react-router';
import { BoxBalancePage } from '@/features/exchange/box-balance-page';

/** رصيد الصندوق: the cashier's box balance per currency (currency.md section 3.1). */
export const Route = createFileRoute('/_app/balance')({
  component: BoxBalancePage,
});
